import { createRoute } from 'framework/routing';

export const LEAD_REPORT_PATH = '/crm/sale/report/lead';

export const useLeadReportPath = () => {
  const routes = createRoute({ listRoute: LEAD_REPORT_PATH });

  return {
    ...routes,
    rawDataRoute: 'raw-data',
  };
};
